import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import dashboardReducer from "../views/admin_views/dashboard/dashboard.reducers";
import adminReducer from "../views/admin_views/admin/admin.reducers";
import usersReducer from "../views/admin_views/users/users.reducers";
import adminAccountReducer from "../views/admin_views/accounts/account.reducers";
import userAccountReducer from "../views/user_views/accounts/account.reducers";
import petitionerPacketReducer from "../views/user_views/forms/petitionerPacket.reducer";
import responsePacketReducer from "../views/user_views/forms/responsePacket.reducer";
import AssestsDebitsReducer from "../views/user_views/forms/disclosure/property/assestDebit/assestsDebits.reducer";
import AssestsDebitsRespondentReducer from "../views/user_views/forms/disclosure/property/assestDebit/assestsDebitsRespondent.reducer";
import servingCourtReducer from "../views/user_views/forms/servingCourt.reducer";
import separatePropertyReducer from "../views/user_views/forms/disclosure/property/separate-property/separateProperty.reducer";
import communityPropertyReducer from "../views/user_views/forms/disclosure/property/community-property/communityProperty.reducer";
import acknowledgementReducer from "../views/user_views/forms/disclosure/acknowledgement/acknowledgement.reducer";
import EntryofJudgementNoticeReducer from "../views/user_views/forms/completeDivorceJudgement/noticeofEntryofJudgement/EntryofJudgementNotice.reducer";
import FamilyLawReducer from '../views/user_views/forms/completeDivorceJudgement/familyLaw/FamilyLaw.reducer';
import childSupportInformationReducer from '../views/user_views/forms/completeDivorceJudgement/childSupportInformation/childSupportInformation.reducer';
import fl142Reducer from '../views/user_views/forms/disclosure/fl-142/FL142.reducer'
import NonGuideLineReducer from '../views/user_views/forms/nonGuideLineChildSupport/NonGuideLine.reducer'
import JudgementPacketFormsReducer from '../views/user_views/forms/completeDivorceJudgement/judgmentPacketForms/judgmentPacketForms.reducer'
import MaritalSettlement from '../views/user_views/forms/maritalSettlementAgreements/maritalSettlement.reducer';
import LandingPageReducer from "../../src/landingPage/landingPage.reducer";
import ProfileInformationReducer from "../../src/views/user_views/forms/profileInformation/profileInformation.reducer";
import ChildInformationReducer from "../views/user_views/forms/childInformation/ChildInformationReducer"
// Use ES6 object literal shorthand syntax to define the object shape
export default (history) =>
  combineReducers({
    router: connectRouter(history),
    dashboardReducer,
    adminReducer,
    usersReducer,
    adminAccountReducer,
    userAccountReducer,
    petitionerPacketReducer,
    responsePacketReducer,
    servingCourtReducer,
    AssestsDebitsReducer,
    AssestsDebitsRespondentReducer,
    separatePropertyReducer,
    communityPropertyReducer,
    acknowledgementReducer,
    LandingPageReducer,
    EntryofJudgementNoticeReducer,
    FamilyLawReducer,
    childSupportInformationReducer,
    fl142Reducer,
    JudgementPacketFormsReducer,
    MaritalSettlement,
    NonGuideLineReducer,
    ProfileInformationReducer,
    ChildInformationReducer,
  });
